module.exports = __webpack_public_path__ + "static/summary_hero_background-e9ee671ac4f405d057bc1983938795ce.png";